import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
    vehicles: [],
    vin: false,
    status: false,
    offers: [],
    sync: false,
}

export const findCar = createAsyncThunk( 'rca/find', async({ CSRFToken, vin}) => {
    const response = await axios({
        method: "get",
        params: {
            VIN: vin
        },
        url: process.env.NEXT_PUBLIC_API + '/api/insurance/rca/search/vin',
        headers: {'Content-Type': 'application/json', CSRFToken},
        withCredentials: true,
    });
    return response.data;
});

const rcaSlice = createSlice({
    name: 'rca',
    initialState,
    reducers: {
        saveVehicles : (state, action) => {
            const {vehicles, status} = action.payload;
            state.vehicles = vehicles;
            state.status = status;
        },
        useVehicle : (state, action) => {
            const {serie_sasiu, step, status} = action.payload;
            let vehicles = state.vehicles.map ( vehicle => vehicle.serie_sasiu == serie_sasiu ? {...vehicle, active: true, step: step} : {...vehicle, active: false, step: false} );
            state.vehicles = vehicles;
            state.status = status;
        },
        saveOffers: (state, action) => {
            const { offers } = action.payload;
            state.offers = offers;
        },
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        syncAccount: (state, action) => {
            const {vehicles} = action.payload;
            state.sync = true;
            state.vehicles = vehicles;
        }
        
    },
    extraReducers: (builder) => {
    builder
        .addCase(findCar.fulfilled, (state, action) => {
            const { status, auto} = action.payload;
            if (status == 'ok') {
                state.vin = auto;
            }  else {
                state.vin = false;
            }
        })
        .addCase(findCar.rejected, (state, action) => {
            state.vin = false;
        });
}
});

export const {saveVehicles, useVehicle, saveOffers, setStatus, syncAccount} = rcaSlice.actions;
export default rcaSlice.reducer;